export const ON_TOGGLE_BANNER = "ON_TOGGLE_BANNER";

export const onToggleBanner = () => ({
  type: ON_TOGGLE_BANNER,
});